import { Formik } from "formik";
import { Spinner } from "react-bootstrap";

import { Form, SubmitButton } from "../../forms";
import ProfileFormFields from "../../../modules/onboarding/components/EntryFormFields";
import Panel from "../../../modules/onboarding/components/Panel";
import {
  Heading,
  Intro,
} from "../../../modules/onboarding/components/Typography";
import useEditEntryScreen from "./useEditEntryScreen";

export default function EditEntryScreen() {
  const { competition, initialValues, onSubmit, schema, entry } =
    useEditEntryScreen();
  return (
    <Panel>
      <Heading>
        {entry?.user ? (
          `${entry.user.firstName} ${entry?.user.lastName}`
        ) : (
          <br />
        )}
      </Heading>
      {entry ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={schema}
        >
          <Form>
            <ProfileFormFields
              competition={competition}
              canChangeCategory={true}
              withAgeGender={false}
              withCompetitorNumber={false}
            />
            <SubmitButton>Save</SubmitButton>
          </Form>
        </Formik>
      ) : (
        <Spinner animation={"border"} />
      )}
    </Panel>
  );
}
